<div class="cw-wrap">
  <h3 class="cw-heading" *ngIf="heading">{{ heading }}</h3>

  <!-- ============================ HARMONY MODE ============================ -->
  <!-- A read-only diagram: the base colour and its opposite partners (the direct
       complementary plus the two split-complementaries flanking it), a line from
       the base to each. The colour is fed in from the harmony-preview beside it. -->
  <div class="color-wheel cw-harmony" *ngIf="harmony">
    <div class="cw-wheel cw-wheel-static" [style.background]="ringGradient">
      <!-- Centre hole: the page background, so it blends into the page (and into the
           warm/cool divider in temperature mode). -->
      <div class="cw-center cw-center-empty"></div>

      <svg class="cw-geo" viewBox="0 0 208 208" aria-hidden="true">
        <!-- Each line is drawn twice: a dark stroke under a white one, so it stays
             visible over any background. -->
        <line class="cw-geo-line-dark" *ngFor="let l of geoLines"
              [attr.x1]="l.x1" [attr.y1]="l.y1" [attr.x2]="l.x2" [attr.y2]="l.y2"></line>
        <line class="cw-geo-line" *ngFor="let l of geoLines"
              [attr.x1]="l.x1" [attr.y1]="l.y1" [attr.x2]="l.x2" [attr.y2]="l.y2"></line>
        <!-- Temperature mode: one long horizontal line splits the wheel into a warm
             top half and a cool bottom half, labelled on the centre disc. -->
        <ng-container *ngIf="divide">
          <line class="cw-temp-divider" x1="0" y1="104" x2="208" y2="104"></line>
          <text class="cw-temp-label" x="104" y="90" text-anchor="middle">Warm</text>
          <text class="cw-temp-label" x="104" y="128" text-anchor="middle">Cool</text>
        </ng-container>
        <!-- Every dot the same size, with a black outline under a white border. The
             base is drawn last so it stays on top when dots overlap (monochrome). -->
        <ng-container *ngFor="let p of dotPoints">
          <circle class="cw-geo-dot-outline" [attr.cx]="p.x" [attr.cy]="p.y" r="10" [attr.fill]="p.hex"></circle>
          <circle class="cw-geo-dot" [attr.cx]="p.x" [attr.cy]="p.y" r="10" [attr.fill]="p.hex"></circle>
        </ng-container>
      </svg>
    </div>

    <!-- The hue angle of each colour in the scheme, beside the wheel (not in the
         temperature split view). -->
    <ul class="cw-hues" *ngIf="!divide">
      <li class="cw-hue" *ngFor="let c of schemeLabels">
        <span class="cw-hue-chip" [style.background]="c.hex"></span>
        <span class="cw-hue-deg">{{ c.hue }}&deg;</span>
      </li>
    </ul>
  </div>

  <!-- ============================ HUE-ONLY MODE =========================== -->
  <div class="color-wheel" *ngIf="!harmony">
    <div class="cw-wheel" #ring
         (pointerdown)="onWheelDown( $event )" (pointermove)="onWheelMove( $event )"
         (pointerup)="onWheelUp()" (pointercancel)="onWheelUp()"
         role="slider" tabindex="0" aria-label="Hue"
         [attr.aria-valuenow]="hue" aria-valuemin="0" aria-valuemax="360">

      <div class="cw-center" [class.cw-center-empty]="temperature" [style.background]="temperature ? null : hex">
        <span class="cw-angle" *ngIf="!temperature" [class.cw-angle-dark]="angleDark">{{ hue }}&deg;</span>
      </div>

      <!-- Temperature mode: split the live ring into a warm top half and a cool
           bottom half, with the same divider + Warm/Cool labels as the color tool. -->
      <svg class="cw-geo" *ngIf="temperature" viewBox="0 0 208 208" aria-hidden="true">
        <line class="cw-temp-divider" x1="0" y1="104" x2="208" y2="104"></line>
        <text class="cw-temp-label" x="104" y="90" text-anchor="middle">Warm</text>
        <text class="cw-temp-label" x="104" y="128" text-anchor="middle">Cool</text>
      </svg>

      <div class="cw-arm" [style.transform]="'rotate(' + hue + 'deg)'">
        <span class="cw-handle cw-knob" [style.background]="hex"></span>
      </div>
    </div>

    <div class="cw-slider" #slider
         (pointerdown)="onSliderDown( $event )" (pointermove)="onSliderMove( $event )"
         (pointerup)="onSliderUp()" (pointercancel)="onSliderUp()"
         role="slider" aria-label="Hue slider"
         [attr.aria-valuenow]="hue" aria-valuemin="0" aria-valuemax="360">
      <span class="cw-slider-thumb cw-knob" [style.left.%]="hue / 360 * 100" [style.background]="hex"></span>
    </div>

    <p class="cw-readout">
      <span class="cw-chip" [style.background]="hex"></span>
      <!-- Temperature widget: name the half the picked hue sits in (Warm / Cool) in
           place of the colour name; the hex stays. Fixed width keeps the row from
           wiggling as the word / hue changes. -->
      <span class="cw-name" *ngIf="!temperature">{{ name }}</span>
      <span class="cw-temp-word" *ngIf="temperature">{{ temperatureWord }}</span>
      <span class="cw-hex">{{ hex }}</span>
    </p>
  </div>
</div>
